import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AuthTwoFactorStartSetupPathParameters } from 'api/actions/auth-two-factor-start-setup/auth-two-factor-start-setup-path-parameters';
import { AuthTwoFactorStartSetupResponse } from 'api/actions/auth-two-factor-start-setup/auth-two-factor-start-setup-response';

type AuthTwoFactorStartSetupQueryParameters = Record<string, any>;

/**
 * The path of the AuthTwoFactorStartSetup action.
 */
export const authTwoFactorStartSetupActionPath = new SweetPath<keyof AuthTwoFactorStartSetupPathParameters>(
  '/api/auth/two-factor/setup/start',
  { path: '{param}' }
);

/**
 * Creates a contextualized AuthTwoFactorStartSetup actions.
 */
export default function createAuthTwoFactorStartSetupAction(axios: AxiosInstance) {
  return function authTwoFactorStartSetupAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: AuthTwoFactorStartSetupQueryParameters } = {}) {
    const path = authTwoFactorStartSetupActionPath.original;

    return axios.request<AuthTwoFactorStartSetupResponse, AuthTwoFactorStartSetupResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
